import { ChangeEventHandler, Ref } from 'react'
import styles from '~/styles/atoms/upload/upload.module.scss'

interface Props {
  onChange: ChangeEventHandler
  inputRef?: Ref<HTMLInputElement>
}

const FileInput = ({
                      onChange,
                      inputRef,
                    }: Props) => {

  return (
    <input className={styles.upload} type="file" onChange={onChange} ref={inputRef} />
  )
}

export default FileInput